import { get } from "@ember/object"
import Component from "@glimmer/component"
import type { LegacyLessonCardStack } from "@shared/models/card-stack"
import { isArray, isNil, sortBy } from "lodash-es"
import styles from "./legacy-lesson-simple-read-only.module.css"

interface Signature {
  Args: {
    lesson: LegacyLessonCardStack
    lessonTitleClass?: string
    showOddMessageIfCardsAreNull?: boolean
  }
}

export default class LegacyLessonSimpleReadOnlyComponent extends Component<Signature> {
  readonly styles = styles

  get shouldShowOddMessage() {
    if (isNil(this.args.lesson)) return false
    let cards = get(get(this.args.lesson, "attributes"), "cards")
    return (
      (isNil(cards) || (isArray(cards) && cards.length === 0)) &&
      this.args.showOddMessageIfCardsAreNull
    )
  }

  get sortedCards() {
    // Not sure why this is undefined sometimes - transient state while the WeeklyTemplates
    // component is being destroyed?
    if (!this.args.lesson) return []

    return sortBy(this.args.lesson.attributes.cards, (card) => get(card.attributes, "position"))
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::CardStacks::LegacyLessonSimpleReadOnly": typeof LegacyLessonSimpleReadOnlyComponent
  }
}
